
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
import { Swipe, SwipeItem, Lazyload, ImagePreview } from 'vant';
Vue.use(Swipe)
  .use(SwipeItem)
  .use(Lazyload);
@Component
export default class HomeDetail extends Vue {
  obj: any = {};
  img: any = [
    'https://image2.cqcb.com/d/file/topics/activity/2022-03-31/6dE0kkRd-1648728382992.jpg',
    'https://image2.cqcb.com/d/file/topics/activity/2022-03-31/fjaMTt1A-1648728382779.jpg',
  ];
  async activated() {
    const res: any = await getDetail(this.$route.query.id);
    this.obj = res.data;
  }
  getImg(imageList: any, index: number) {
    const scroll =
      document.documentElement.scrollTop || document.body.scrollTop;
    ImagePreview({
      images: imageList, // 预览图片的那个数组
      showIndex: true,
      loop: false,
      startPosition: index, // 指明预览第几张图
      onClose() {
        document.documentElement.scrollTop = scroll;
        document.body.scrollTop = scroll;
      },
    });
  }
}
